(function () {
  'use strict';

  var cookieName = 'femily_first_purchase_popup_seen_v1';
  var maxAge = 14 * 24 * 60 * 60;

  function hasSeen() {
    return document.cookie.indexOf(cookieName + '=1') > -1;
  }

  function recordSeen() {
    document.cookie = cookieName + '=1; path=/; max-age=' + maxAge + '; samesite=lax';
  }

  function markSeen() {
    recordSeen();
    document.documentElement.classList.add('femily-first-purchase-popup-seen');
  }

  function removeNewsletterPopup() {
    document.querySelectorAll('#t4s-popup__newsletter').forEach(function (popup) {
      popup.remove();
    });

    document.querySelectorAll('.t4s-newsletter_pp_wrapper').forEach(function (overlay) {
      overlay.remove();
    });
  }

  function suppressFutureFetches() {
    if (!window.T4SThemeSP || !window.T4SThemeSP.PopupFetch || window.T4SThemeSP.__femilyPopupFetchSuppressed) return;
    window.T4SThemeSP.PopupFetch = function () { return Promise.resolve(); };
    window.T4SThemeSP.__femilyPopupFetchSuppressed = true;
  }

  function suppressIfSeen() {
    if (!hasSeen()) return;
    suppressFutureFetches();
    removeNewsletterPopup();
  }

  function popupExistsInside(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id === 't4s-popup__newsletter') return true;
    return Boolean(node.querySelector && node.querySelector('#t4s-popup__newsletter'));
  }

  function recordIfPopupExists() {
    if (document.querySelector('#t4s-popup__newsletter')) recordSeen();
  }

  function watchPopupInsertion() {
    if (!window.MutationObserver || !document.documentElement) return;
    var observer = new MutationObserver(function (mutations, currentObserver) {
      for (var i = 0; i < mutations.length; i += 1) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j += 1) {
          if (popupExistsInside(addedNodes[j])) {
            recordSeen();
            currentObserver.disconnect();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.mfp-close') || event.target.closest('#t4s-popup__newsletter [type="submit"]')) {
      markSeen();
    }
  }, true);

  suppressIfSeen();
  document.addEventListener('DOMContentLoaded', suppressIfSeen, { once: true });
  watchPopupInsertion();
  window.setTimeout(recordIfPopupExists, 38000);
  window.setTimeout(recordIfPopupExists, 38700);
  window.setTimeout(suppressIfSeen, 50);
  window.setTimeout(suppressIfSeen, 600);
  window.setTimeout(suppressIfSeen, 1700);
}());